
import { Building, Users, Landmark, CreditCard, Home, Briefcase, BarChart, ShoppingCart, Ship, Warehouse } from "lucide-react";

export const UserTypes = () => {
  return (
    <div className="container mx-auto px-4 py-20 bg-gradient-to-b from-white to-purple-50/50">
      <h2 className="text-3xl font-bold text-center mb-12 bg-gradient-to-r from-indigo-800 to-purple-600 bg-clip-text text-transparent">Who Can Use Obotan</h2>
      
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* Personal Section */}
        <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 p-8 border border-gray-100 transform hover:-translate-y-2">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-full flex items-center justify-center shadow-md">
              <Users className="h-8 w-8 text-white" />
            </div>
            <h3 className="text-2xl font-semibold text-gray-800">Personal</h3>
          </div>
          
          <ul className="space-y-4">
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <CreditCard className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Loans</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <ShoppingCart className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Credit Purchases</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <BarChart className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Credit Sales</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <Ship className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Port Clearing</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <Home className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Housing and Land</span>
            </li>
          </ul>
        </div>
        
        {/* Business Section */}
        <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 p-8 border border-gray-100 transform hover:-translate-y-2">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-full flex items-center justify-center shadow-md">
              <Building className="h-8 w-8 text-white" />
            </div>
            <h3 className="text-2xl font-semibold text-gray-800">Business</h3>
          </div>
          
          <ul className="space-y-4">
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <Briefcase className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Import Advance Payment</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <Ship className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Port Clearing</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <Warehouse className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Warehousing Stocking</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <ShoppingCart className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Credit Purchases</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <CreditCard className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Working Capital</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <BarChart className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Credit Sales</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <Home className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Real Estate</span>
            </li>
          </ul>
        </div>

        {/* Community Section */}
        <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 p-8 border border-gray-100 transform hover:-translate-y-2">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-full flex items-center justify-center shadow-md">
              <Users className="h-8 w-8 text-white" />
            </div>
            <h3 className="text-2xl font-semibold text-gray-800">Community</h3>
          </div>
          
          <ul className="space-y-4">
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <Home className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Development</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <CreditCard className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Loans</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <ShoppingCart className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Trade</span>
            </li>
          </ul>
        </div>
        
        {/* Government Section */}
        <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 p-8 border border-gray-100 transform hover:-translate-y-2">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-full flex items-center justify-center shadow-md">
              <Landmark className="h-8 w-8 text-white" />
            </div>
            <h3 className="text-2xl font-semibold text-gray-800">Government</h3>
          </div>
          
          <ul className="space-y-4">
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <Briefcase className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Loans to SMEs</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <BarChart className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Credit Sale to SMEs</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <ShoppingCart className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Credit Purchases for SMEs</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <Home className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Specialized Projects</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <CreditCard className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Infrastructure Projects</span>
            </li>
            <li className="flex items-start gap-3 group">
              <div className="mt-0.5 p-1.5 rounded-full bg-indigo-100 group-hover:bg-indigo-200 transition-colors">
                <Warehouse className="h-4 w-4 text-indigo-600" />
              </div>
              <span className="text-gray-700 group-hover:text-indigo-700 transition-colors">Developments</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
